import { useState } from "react";
import axios from "axios";
import { getApiBase } from "../utils/config";
import "./Login.css";

const API_BASE = getApiBase();

export default function Login({ onAuth, notify }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const submit = async () => {
    if (!email || !password) {
      notify?.("Email and password are required", "warning");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/auth/login`, { email, password });
      const token = res?.data?.token;
      if (!token) throw new Error("No token returned");
      localStorage.setItem("token", token);
      const expiry = Date.now() + 24 * 60 * 60 * 1000; // 24 hours
      localStorage.setItem("tokenExpiry", String(expiry));
      notify?.("Login successful!", "success");
      onAuth?.(token, res?.data?.user);
    } catch (e) {
      console.error(e);
      notify?.(e?.response?.data?.message || e.message || "Auth failed", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2 className="login-title">Digital Dekho Automation</h2>
        <p className="login-subtitle">Login to continue</p>

        <div className="login-field">
          <label className="login-label">Email</label>
          <div className="login-input-wrap">
            <input
              className="login-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
            />
          </div>
        </div>

        <div className="login-field">
          <label className="login-label">Password</label>
          <div className="login-input-wrap">
            <input
              className="login-input has-toggle"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              autoComplete="current-password"
            />

            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              title={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? (
                // eye-off
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M3 3l18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <path
                    d="M10.6 10.6a3 3 0 0 0 4.2 4.2"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M9.9 5.2A10.6 10.6 0 0 1 12 5c6 0 10 7 10 7a19 19 0 0 1-4.2 5.3M6.3 6.3A18.7 18.7 0 0 0 2 12s4 7 10 7a10.7 10.7 0 0 0 3.1-.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                // eye
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>

        <button onClick={submit} disabled={loading} className="login-button">
          {loading ? "Please wait..." : "Login"}
        </button>
      </div>
    </div>
  );
}


